import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import { SlaGauge } from 'src/app/shared/model/cybersocxdr/slagauge';
import { CybersocXDRDashboardSearchCriteria } from '../../shared/model/searchCriteria';
import { CybersocxdrService } from '../../shared/services/xtendedsoc/cybersocxdr.service';
import { CaseXDR } from 'src/app/shared/model/cybersocxdr/microsocticket';

@Component({
  selector: 'app-cybersocxdashboard',
  templateUrl: './cybersocxdrsla.component.html',
  styleUrls: ['./cybersocxdrsla.component.scss'],
})
export class CybersocxdrSLAComponent implements OnInit {
  page: 'notification' | 'investigation';

  histogramSLANotifStatusData: any;
  histogramSLAInvestStatusData: any;

  slaNotifGaugeData: SlaGauge;
  slaInvestGaugeData: SlaGauge;
  slaNotifStatusRateData: any;
  slaInvestRateData: any;
  mttdData: any;
  mttiData: any;
  brokenNotificationCases: CaseXDR[];
  brokenInvestigationCases: CaseXDR[];
  displayedCases: CaseXDR[]; // Simple container to select which cases to display of the table
  createdFrom: string;
  createdTo: string;

  highcharts: typeof Highcharts = Highcharts;

  constructor(private cybersocxdrService: CybersocxdrService, private translate: TranslateService) {}

  async search(searchCriteria: CybersocXDRDashboardSearchCriteria) {
    this.createdFrom = searchCriteria.createdFrom;
    this.createdTo = searchCriteria.createdTo;

    if (this.page === 'investigation') {
      await this.searchInvestigation(searchCriteria);
      await this.searchNotification(searchCriteria);
    } else {
      await this.searchNotification(searchCriteria);
      await this.searchInvestigation(searchCriteria);
    }
    this.selectDisplayedCases();
  }

  selectDisplayedCases() {
    this.displayedCases = {
      notification: this.brokenNotificationCases,
      investigation: this.brokenInvestigationCases,
    }[this.page];
  }

  /** Update all the info used for the notification SLA tab */
  async searchNotification(criteria: CybersocXDRDashboardSearchCriteria) {
    [
      this.slaNotifGaugeData,
      this.slaNotifStatusRateData,
      this.histogramSLANotifStatusData,
      this.mttdData,
      this.brokenNotificationCases,
    ] = await Promise.all([
      this.cybersocxdrService.getSLANotifGauge(criteria),
      this.cybersocxdrService.getSLANotifStatusRate(criteria),
      this.cybersocxdrService.getHistogramSLANotifStatus(criteria),
      this.cybersocxdrService.getMTTDOverTime(criteria),
      this.cybersocxdrService.getCases({ ...criteria, slaNotificationStatusBroken: true, skip: 0, limit: 45 }),
    ]);
  }

  /** Update all the info used for the investigation SLA tab */
  async searchInvestigation(criteria: CybersocXDRDashboardSearchCriteria) {
    [
      this.slaInvestGaugeData,
      this.slaInvestRateData,
      this.histogramSLAInvestStatusData,
      this.mttiData,
      this.brokenInvestigationCases,
    ] = await Promise.all([
      this.cybersocxdrService.getSLAInvestGauge(criteria),
      this.cybersocxdrService.getSLAInvestStatusRate(criteria),
      this.cybersocxdrService.getHistogramSLAInvestStatus(criteria),
      this.cybersocxdrService.getMTTIOverTime(criteria),
      this.cybersocxdrService.getCases({ ...criteria, slaInvestigationStatusBroken: true, skip: 0, limit: 45 }),
    ]);
  }

  ngOnInit() {
    this.page = 'notification';
  }
}
